var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M89.38,30.21A10.28,10.28,0,0,0,82.11,23C75.7,21.23,50,21.23,50,21.23s-25.7,0-32.12,1.72a10.28,10.28,0,0,0-7.26,7.26C8.9,36.62,8.9,50,8.9,50s0,13.37,1.72,19.78a10.28,10.28,0,0,0,7.26,7.27C24.3,78.77,50,78.77,50,78.77s25.7,0,32.11-1.72a10.27,10.27,0,0,0,7.27-7.27C91.1,63.37,91.1,50,91.1,50S91.1,36.62,89.38,30.21ZM41.78,62.33V37.67L63.13,50Z"}));
}

Youtube.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 100 100"};

module.exports = Youtube;

Youtube.default = Youtube;
